import { inject, observer } from 'mobx-react';

import styles from './EditNoteCaption.module.scss';

import { Icon, IconType } from '@components/Icon';
import { translate } from '@chaika/i18n/helper';
import type { Entry } from '@patient/store/entry/Entry';

interface StoreProps {
    entry: Entry;
}

export const EditNoteCaption = inject<{}, StoreProps>('entry')(
    observer(({ entry }: StoreProps) => {
        const hasNote = !!entry.note?.trim();

        return (
            <div className={styles.root}>
                <div className={styles.captionWrapper}>
                    <div className={styles.caption}>{translate('noteCaption').toLowerCase()}</div>
                    {hasNote && (
                        <span className={styles.indicatorIcon}>
                            <Icon type={IconType.CHECK_REDESIGN} />
                        </span>
                    )}
                </div>
            </div>
        );
    }),
);
